import React, { Component } from 'react';
import Comment from '../../../../common/comments/comment.component';
import { MAX_LENGTH } from '../../../../../constants/external-constants';
import { Loading } from '../../../../common/loading';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { locationSiteCommentActions } from '../../../../../store/external/inventory/locationsite/location-site-comments.reducer';

class LocationSiteComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        const { getLocationSiteComments, locationComments, locationId }  = this.props;
        getLocationSiteComments(locationId, locationComments?.pageIndex, 5, false)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    postComment = async (attachedFilename, attachedFileData, commentDescription) => {
        const { postLocationSiteComments, locationId } = this.props;
        await postLocationSiteComments(locationId, attachedFilename, attachedFileData, commentDescription);
    }

    handleDeleteLocationComments = async (locationSiteId) => {
        this.setState({ isLoading: true });
        const { deleteLocationSiteComments, getLocationSiteComments, clearLocationSiteComments, locationComments, locationId } = this.props;
        await deleteLocationSiteComments(locationSiteId, locationId);
        await clearLocationSiteComments()
        await getLocationSiteComments(locationId, 1, locationComments?.locationSiteComments?.length).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    handleLoadMore = async () =>{
        const { getLocationSiteComments, locationComments, locationId } = this.props;
        await getLocationSiteComments(locationId, locationComments.pageIndex + 1)
    }

    componentWillUnmount(){
        const { clearLocationSiteComments } = this.props;
        clearLocationSiteComments();
    }
    render() {
        const { locationSiteComments, hasMoreComments } = this.props.locationComments;
        if (this.state.isLoading) {
            return <Loading />
        }

        return (
            <div>
                <Comment
                    commentList={locationSiteComments}
                    addCommentAction={this.postComment}
                    deleteCommentAction={this.handleDeleteLocationComments}
                    maxLength={MAX_LENGTH.limit_500}
                    isLocationComment={true}
                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={hasMoreComments}
                    //Access Type
                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite}
                />
            </div>
        );
    }
}

export default connect(
    state => {
        const { locationComments } = state;
        
        return {
            locationComments
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, locationSiteCommentActions),
        dispatch
    )
)(LocationSiteComment);